import * as React from "react";

function SvgImport(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 22 22" fill="none" {...props}>
      <path d="M22 0H6v6h2V2h12v18H8v-4H6v6h16V0z" fill="#fff" />
      <path
        d="M10 4h8v2h-8V4zM10 8h8v2h-8V8zM10 12h8v2h-8v-2zM10 16h4v2h-4v-2zM5 14v-2H0v-2h5V8l3 3-3 3z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgImport;
